export default __webpack_public_path__ + "static/media/lp_screenshot2.45c870c3.png";